import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('mcaToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('mcaToken');
      localStorage.removeItem('mcaUser');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (email, password, role) =>
    api.post('/auth/login', { email, password, role }),
  register: (userData) => api.post('/auth/register', userData),
};

export const applicationsAPI = {
  getAll: (params) => api.get('/applications', { params }),
  getOne: (id) => api.get(`/applications/${id}`),
  create: (data) => api.post('/applications', data),
  update: (id, data) => api.put(`/applications/${id}`, data),
  updateStatus: (id, status, notes) =>
    api.patch(`/applications/${id}/status`, { status, notes }),
  delete: (id) => api.delete(`/applications/${id}`),
};

export const lendersAPI = {
  getAll: () => api.get('/lenders'),
  getOne: (id) => api.get(`/lenders/${id}`),
  submit: (lenderId, applicationId) =>
    api.post(`/lenders/${lenderId}/submit?application_id=${applicationId}`),
};

export const dealsAPI = {
  getAll: () => api.get('/deals'),
  getOne: (id) => api.get(`/deals/${id}`),
  create: (data) => api.post('/deals', data),
  recordPayment: (id, amount) =>
    api.patch(`/deals/${id}/payment`, { amount }),
};

export const analyticsAPI = {
  getDashboard: () => api.get('/analytics/dashboard'),
  getMonthly: () => api.get('/analytics/monthly'),
  getBreakdown: () => api.get('/analytics/breakdown'),
};

export const notificationsAPI = {
  getAll: () => api.get('/notifications'),
  markAsRead: (id) => api.patch(`/notifications/${id}/read`),
  delete: (id) => api.delete(`/notifications/${id}`),
};

export const userAPI = {
  getProfile: () => api.get('/user/profile'),
  updateProfile: (data) => api.put('/user/profile', data),
  changePassword: (data) => api.put('/user/password', data),
  getSettings: () => api.get('/user/settings'),
  updateSettings: (data) => api.put('/user/settings', data),
};

export const teamAPI = {
  getAll: () => api.get('/team'),
};

export default api;
